import { BusinessApi, Business } from '../models';

export function mapBusinessApiToBusiness(businessApi: BusinessApi): Business {
  return {
    id: businessApi.id,
    name: businessApi.name,
    invoiceRange: businessApi.invoiceRange,
    lastInvoice: businessApi.lastInvoice,
    status: businessApi.status,
  };
}
